import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning-colonie-ny")({
  beforeLoad: () => {
    throw redirect({ to: "/roof-washing-colonie-ny", statusCode: 301 });
  },
});
